import { z } from 'zod/v4'
import {
  InstanceFindCommandSchema,
  InstanceCreateCommandSchema,
  InstanceUpdateCommandSchema,
  InstanceUpsertCommandSchema,
  InstanceUpsertManyCommandSchema,
  InstanceListCommandSchema,
  InstanceCountCommandSchema,
} from './schemas'

// CRM commands
export const CRMCommandSchema = z.enum([
  'instance.find',
  'instance.list',
  'instance.count',
  'instance.create',
  'instance.update',
  'instance.upsert',
  'instance.upsertMany',
])

// CRM service schema
export const CRMServiceSchema = z.union([
  InstanceFindCommandSchema,
  InstanceListCommandSchema,
  InstanceCountCommandSchema,
  InstanceCreateCommandSchema,
  InstanceUpdateCommandSchema,
  InstanceUpsertCommandSchema,
  InstanceUpsertManyCommandSchema,
])

// CRM service types
export type CRMCommand = z.infer<typeof CRMCommandSchema>
export type CRMService = z.infer<typeof CRMServiceSchema>
